<div class="header-upload" *ngIf="visible" (click)="$event.stopPropagation()">
  <button
    type="button"
    class="header-upload__trigger"
    (click)="togglePanel($event)"
    [attr.aria-expanded]="panelOpen"
    aria-label="Upload progress"
    title="Upload in progress"
  >
    <span class="header-upload__ring" [style.--progress]="ringProgress + '%'" aria-hidden="true">
      <span class="header-upload__ring-inner">
        <svg class="header-upload__icon" viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M11 16V7.83l-3.59 3.59L6 10l6-6 6 6-1.41 1.41L13 7.83V16h-2zm-7 2h14v2H4v-2z"
          />
        </svg>
      </span>
    </span>
  </button>

  <div class="header-upload__panel" *ngIf="panelOpen" role="dialog" aria-label="Upload progress">
    <ul class="header-upload__list">
      <li class="header-upload__item" *ngFor="let job of jobs">
        <p class="header-upload__filename">{{ truncateName(job.fileName) }}</p>
        <div class="header-upload__bar" *ngIf="job.status === 'uploading'">
          <div class="header-upload__bar-fill" [style.width.%]="job.value">
            <span class="header-upload__bar-label">{{ job.value }}%</span>
          </div>
        </div>
        <p class="header-upload__status" *ngIf="job.status === 'finalizing'">Processing…</p>
        <p class="header-upload__status header-upload__status--done" *ngIf="job.status === 'done'">Complete</p>
        <p class="header-upload__status header-upload__status--error" *ngIf="job.status === 'error'">
          {{ job.errorMessage || 'Upload failed' }}
        </p>
      </li>
    </ul>
  </div>
</div>
